import type { HazWasteGeneratorStatus } from '../../tri-shared/types/db.ts';

export interface ManifestLineIdentityInput {
  wasteDescription?: string;
  dotInformation?: { idNumber?: { code?: string } };
  hazardousWaste?: {
    federalWasteCodes?: { code: string }[];
    generatorStateWasteCodes?: { code: string }[];
  };
  quantity?: { containerType?: { code?: string } };
}

export function hazWasteExceptionDeadlineDays(status: HazWasteGeneratorStatus | null | undefined): 45 | 60 {
  return !status || status === 'lqg' ? 45 : 60;
}

export function manifestLineIdentityKey(waste: ManifestLineIdentityInput): string {
  const federalCodes = waste.hazardousWaste?.federalWasteCodes?.map((code) => code.code.trim().toUpperCase()) ?? [];
  const stateCodes =
    waste.hazardousWaste?.generatorStateWasteCodes?.map((code) => code.code.trim().toUpperCase()) ?? [];
  return JSON.stringify({
    dotIdNumber: waste.dotInformation?.idNumber?.code?.trim().toUpperCase() ?? '',
    description: waste.wasteDescription?.trim().toLowerCase() ?? '',
    codes: [...federalCodes, ...stateCodes].sort(),
    containerType: waste.quantity?.containerType?.code?.trim().toUpperCase() ?? '',
  });
}
